import { useState, useMemo, useEffect } from 'react'
import { validateCaseParameters } from '../core/engine/inputConsistency'

export function useCaseValidation(expediente, activeRules, expedienteCalculo, onForceStrategy) {
  const [warningsAcknowledged, setWarningsAcknowledged] = useState(false)

  const caseValidationInput = useMemo(() => {
    const scenarioKey = String(activeRules?.caseMeta?.scenarioKey || '')
    let regimeType = 'GENERAL_DEPENDENCIA'
    if (scenarioKey.includes('DOCENTE') || expediente?.esDocente) regimeType = 'ESPECIAL_DOCENTE'
    else if (scenarioKey.includes('MIXTO')) regimeType = 'MIXTO'
    return {
      ...expediente,
      regimeType,
      fechaCorteCalculo: expedienteCalculo?.fechaCorteCalculo || activeRules?.liquidacionFinal?.fechaCorte || '',
    }
  }, [expediente, activeRules?.caseMeta?.scenarioKey, activeRules?.liquidacionFinal?.fechaCorte, expedienteCalculo?.fechaCorteCalculo])

  const caseValidation = useMemo(() => validateCaseParameters(caseValidationInput), [caseValidationInput])

  const blockingIssuesStageA = useMemo(
    () => (caseValidation.blockingIssues || []).filter((msg) =>
      /regimen|pension|configuracion incompatible|docente|continuidad|sueldo bruto/i.test(String(msg))),
    [caseValidation.blockingIssues],
  )
  const blockingIssuesStageB = useMemo(
    () => (caseValidation.blockingIssues || []).filter((msg) => /temporal|fecha/i.test(String(msg))),
    [caseValidation.blockingIssues],
  )
  const wizardStageABValid = blockingIssuesStageA.length === 0 && blockingIssuesStageB.length === 0

  useEffect(() => {
    setWarningsAcknowledged(false)
  }, [caseValidation.warnings])

  useEffect(() => {
    const strategy = caseValidation?.derivedStrategy
    if (!strategy?.lockUserChoice) return
    const forced = String(strategy.indice || '').trim()
    if (!forced) return
    if (typeof onForceStrategy === 'function') onForceStrategy(forced)
  }, [caseValidation?.derivedStrategy, caseValidation?.derivedStrategy?.indice, onForceStrategy])

  return {
    caseValidation,
    blockingIssuesStageA,
    blockingIssuesStageB,
    wizardStageABValid,
    warningsAcknowledged,
    setWarningsAcknowledged,
  }
}

export default useCaseValidation
